import { atom } from "../app-jotai";

// Open-state atoms for the cloud dialogs (mirrors shareDialogStateAtom pattern).

export const saveToCloudDialogAtom = atom<
  { isOpen: false } | { isOpen: true; mode: "save" | "saveAs" }
>({ isOpen: false });

export const cloudBrowserDialogAtom = atom<boolean>(false);

// "Open" chooser: From file / From cloud.
export const openChooserDialogAtom = atom<boolean>(false);

export const versionHistoryDialogAtom = atom<
  { isOpen: false } | { isOpen: true; docId: string; name: string }
>({ isOpen: false });

export const shareLinkDialogAtom = atom<
  { isOpen: false } | { isOpen: true; url: string; expiresAt: number | null }
>({ isOpen: false });

// Transient save-status indicator (requirement VER-4).
export const cloudSaveStatusAtom = atom<"idle" | "saving" | "saved" | "error">(
  "idle",
);
